import { render, staticRenderFns } from "./lrDepartment.vue?vue&type=template&id=e06a4cea&scoped=true&"
import script from "./lrDepartment.vue?vue&type=script&lang=js&"
export * from "./lrDepartment.vue?vue&type=script&lang=js&"
import style0 from "./lrDepartment.vue?vue&type=style&index=0&id=e06a4cea&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06a4cea",
  null
  
)

export default component.exports